import NewsletterTwentySevenContainer from "./container/NewsletterTwentySevenContainer";
export default NewsletterTwentySevenContainer;
